<template>
    <b-modal ref="mapShortcutsModal" centered title="Skróty klawiszowe" size="lg" @show="onShow" @hidden="hide" @ok="hide" ok-only ok-title="Zamknij">
       <div>
         <p v-for="shortcut in activeShortcuts" :key="shortcut.action">
          <b>{{ shortcut.key }}</b>
          <b v-if="shortcut.modifier">+ {{ shortcut.modifier }}</b>
          -
          {{ shortcut.action }}
         </p>
         <b-alert :show="activeShortcuts.length === 0" variant="info" class="mb-0"><strong>Informacja.</strong> Brak zdefiniowanych skrótów klawiszowych.</b-alert>
      </div>
    </b-modal>
</template>

<script>
import { WINDOW_MAP_SHORTCUTS_HIDE } from "../store/mutations.type";
import { activeShortcutsList } from "../store/keyShortcuts.module";

export default {
  name: "MapShortcutsWindow",
  data: function() {
    return {
      activeShortcuts: []
    };
  },
  methods: {
    onShow() {
      this.activeShortcuts = activeShortcutsList.filter(x => !x.permissionId || this.$context.hasPermission(x.permissionId));
    },
    hide() {
      this.$store.commit(WINDOW_MAP_SHORTCUTS_HIDE);
    },
  },
  created() {
    let vm = this;
    vm.$store.watch(
      () => vm.$store.getters.showMapShortcutsWindowVisible,
      (value, oldValue) => {
        let modal = vm.$refs.mapShortcutsModal;
        let method = value ? modal.show : modal.hide;

        method.call(modal);
      }
    );
  }
};
</script>